class DragManager {

    _container?: HTMLElement;
    _touchArea?: HTMLElement;

    constructor() {

    }

    init(container: any, touchArea: any) {
        this._container = container;
        this._touchArea = touchArea

        this._touchArea!.addEventListener('mousedown', this.handleMouseDown)
        this._touchArea!.addEventListener('mouseup', this.handleMouseUp)
    }

    dispose() {

        if (this._touchArea) {
            this._touchArea!.removeEventListener('mousedown', this.handleMouseDown)
            this._touchArea!.removeEventListener('mouseup', this.handleMouseUp)

            window.removeEventListener('mousemove', this.handleDrag)
        }

    }

    handleMouseDown = (e: MouseEvent) => {

        // otherwise when moving mouse while mouse down
        // we dont have new mouseX values
        e.preventDefault();

        window.addEventListener('mousemove', this.handleDrag)
    }

    handleMouseUp = (e: MouseEvent) => {
        window.removeEventListener('mousemove', this.handleDrag)
    }

    handleDrag = (e: any) => {

        e.preventDefault();

        let movementX = e.movementX
        let mouvementY = e.movementY

        const {x, y} = this._container!.getBoundingClientRect()

        this._container!.style.left = `${x + movementX}px`
        this._container!.style.top = `${y + mouvementY}px`

        // this._container!.style.left = `${x}px`
        // this._container!.style.top = `${y }px`

        console.log(this._container!.style.left, this._container!.style.top)
    }

}

export default DragManager